Namespace 'Monitoring.Models.SocialContents.GoogleMyBusiness.Builders'

class Monitoring.Models.SocialContents.GoogleMyBusiness.Builders.GoogleMyBusinessReplyBuilder
  setText: (text) =>
    @text = text

  getText: =>
    @text

  setCreatedAt: (createdAt) =>
    @createdAt = createdAt

  getCreatedAt: =>
    @createdAt

  setContentId: (contentId) =>
    @contentId = contentId

  getContentId: =>
    @contentId

  setReviewSnapshot: (reviewSnapshot) =>
    @reviewSnapshot = reviewSnapshot

  getReviewSnapshot: =>
    @reviewSnapshot

  build: =>
    new Monitoring.Models.SocialContents.GoogleMyBusiness.GoogleMyBusinessReply(@)
